import * as React from 'react'
import { LayoutApp } from 'components/shared/layouts/LayoutApp'
import { layoutService } from 'services/LayoutService'
import { Meta } from 'components/shared/Meta'
import { Title } from '../shared/ui/Title'
import { PageFrame } from '../../base/components/ui/PageFrame'
import styles from './ViewExplore.module.scss'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8 } from '../../assets/images/explore'

const sections = [
  {
    image: Image1,
    text: 'In a simple infectious disease model there are three key ‘stocks’. These are people who are susceptible to the infection, those who are infected and those who have recovered. In this model it is assumed that once recovered you are no longer susceptible The ‘pipes’ connecting the stocks, represent the flow of people from being susceptible, to being infected and finally recovered.',
  },
  {
    image: Image2,
    text: 'The rate at which the infection spreads is determined by the probability of a susceptible person coming into contact with someone who is infected.',
  },
  {
    image: Image3,
    text: 'This probability is determined, in the model, by the number of contacts infected people have.',
  },
  {
    image: Image4,
    text: 'And the probability that any of those contacts are going to be with a susceptible person',
  },
  {
    image: Image5,
    text: 'A proportion of individuals who become infected will die from the disease. This directly reduces the number of people who recover from the disease.',
  },
  {
    image: Image6,
    text: 'We can use this model to explore the impact of being able to change the probability of getting the infection.',
  },
  {
    image: Image7,
    text: 'We can then explore the impact of a vaccination programme. This will be affected by the efficacy of the vaccine and the proportion of the population vaccinated.',
  },
  {
    image: Image8,
    text: 'We can also explore the impact of any changes to the duration of the illness.',
  },
]

export const ViewExplore = () => {

  const [activeSection, setActiveSection] = React.useState(0)
  const textsContainer = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    layoutService.setHeaderLarge(false)
    layoutService.setBreadcrumbs([{ label: 'Introduction' }])
  }, [])

  React.useEffect(() => {
    if (textsContainer.current === null) {
      return
    }
    const textBlocks = textsContainer.current.querySelectorAll('div')
    textBlocks.forEach((el: Element, i: number) => {
      handleEachBlock(el, i)
    })
  }, [])

  function handleEachBlock(target: Element, i: number) {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    }

    new IntersectionObserver(handleIntersect, options).observe(target)

    function handleIntersect(entries: any, observer: any) {
      entries.forEach((entry: { intersectionRatio: number; }) => {
        if (entry.intersectionRatio === 1) {
          setActiveSection(i)
        }
      })
    }
  }

  return (
    <LayoutApp>
      <Meta title="Introduction" />
      <PageFrame simple>
        <div className={styles.root}>
          <div className={styles.content}>
            <Title type={'h1'}>Explore Model</Title>
            <div className={styles.text}>
              <div className={styles.sectionContainer}>
                <div className={styles.sectionImages}>
                  {
                    sections.map((section, id) => (
                      <div key={id}
                           className={`${styles.sectionImage} ${id === activeSection ? styles.sectionImageActive : ''}`}
                           style={{ backgroundImage: `url(${section.image})` }}
                      />
                    ))
                  }
                  <div className={styles.scrollTo}>
                    {activeSection !== sections.length - 1 && <div>
                      <span>Scroll Down</span>
                      <KeyboardArrowDownIcon />
                    </div>}
                    {activeSection === sections.length - 1 &&
                    <div className={styles.scrollToButton} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                      <KeyboardArrowUpIcon />
                      <span>Click to return to top</span>
                    </div>}
                  </div>
                </div>
                <div ref={textsContainer} className={styles.sectionTexts}>
                  {
                    sections.map((section, id) => (
                      <div key={id} className={styles.sectionText} dangerouslySetInnerHTML={{ __html: section.text }} />
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageFrame>
    </LayoutApp>
  )
}
